import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {AppState} from "../RootReducer";
import {getVisibleCurrencies} from "../selectors/user-selectors";
import {AccountRole} from "../http/protocol";
import {hasFiatExchangeAmount, toFiatAmount} from "../currency/currency-utils";
import CurrencyFormatter from "../utils/CurrencyFormatter";
import Big from "big.js";
import {getCurrencyDefinitions, getPreferredFiatExchange} from "../selectors/settings-selectors";
import "./styles/BalancesPage.scss";
import {t} from "../i18n";
export interface FormattedBalance  {
    loading : boolean;
    currencyName? : string;
    currencyCode? : string;
    balance : string;
    reservedBonus : string;
    fiatExchange? : string;
    bonusFiatExchange?: string;
}

export const BalancesPage = () => {
    const currencyDefinitions = useSelector((app : AppState) => getCurrencyDefinitions(app));
    const initialBalanceFetched = useSelector((app : AppState) => app.user.initialBalanceFetched);
    const currencies = useSelector((app : AppState) => getVisibleCurrencies(app))
    const balances = useSelector((app : AppState) => app.user.balances);
    const preferredExchangeCurrency = useSelector((app : AppState) => getPreferredFiatExchange(app));
    let hasReservedAmount = false;
    const displayBalances : FormattedBalance[]  = currencies.map(c => {
        if(!initialBalanceFetched) {
            return { loading : true, currencyName : c.name, currencyCode : c.code, balance : "-", reservedBonus : "-"}
        }
        let balance = balances?.find(b => b?.balance?.currencyCode == c.code && b.role == AccountRole.MAIN);
        let fiatExchange : string | undefined = undefined;
        let bonusFiatExchange : string | undefined = undefined;
        if(c.code && balance?.balance?.amount && hasFiatExchangeAmount(c.code, preferredExchangeCurrency,currencyDefinitions)) {
            fiatExchange = toFiatAmount(c.code,balance.balance.amount,preferredExchangeCurrency,currencyDefinitions);
            if(balance.reservedBonus?.amount ) {
                bonusFiatExchange =  toFiatAmount(c.code,balance.reservedBonus.amount,preferredExchangeCurrency,currencyDefinitions);
            }
        }
        if(balance?.reservedBonus?.amount ?? 0 > 0) {
            hasReservedAmount = true;
        }
        let reservedBonusAmount:any = balance?.reservedBonus?.amount != 0 ? CurrencyFormatter.formatWithSymbol(c, new Big(balance?.reservedBonus?.amount ?? 0)) : "";
        return {
                loading: false,
                currencyName: c.name,
                currencyCode: c.code,
                balance: CurrencyFormatter.formatWithSymbol(c, new Big(balance?.balance?.amount ?? 0)),
                reservedBonus: reservedBonusAmount,
                fiatExchange: fiatExchange,
                bonusFiatExchange : bonusFiatExchange
            }
        })

    useEffect(() => {
        window.scroll(0,0);
    })

    return (
        <div className={"content-padding"}>
            <h4 className={"section"}>{t("balances-page.account-balances")}</h4>
            <div className={"balances-container"}>

               <table className={"table table-striped balances-table"}>
                   <thead>
                        <tr>
                            <th className={'hide-in-context'}></th>
                            <th>{t("balances-page.currency")}</th>
                            <th className={"balance"}>{t("balances-page.total-balance")}</th>
                            {hasReservedAmount && <th className={"bonus-balance"}>{t("balances-page.bonus-amount")}</th>}
                        </tr>
                   </thead>
                   <tbody>
                   {displayBalances.map(c => (
                       <tr key={c.currencyCode}>
                           <td className={'hide-in-context'}>
                               <div className={"currency-icon-container"}>
                                   <i className={"balance-page-currency-icon currency-icon currency-icon-"+c.currencyCode?.toLocaleLowerCase()}></i>
                               </div>
                           </td>
                           <td>{c.currencyName}</td>
                           <td className={"balance"}>
                               <span>{c.balance}</span>
                               {c.fiatExchange && <span className={"fiat-amount"}>{c.fiatExchange}</span>}
                           </td>
                           {hasReservedAmount && <td className={"bonus-balance balance"}>
                               <span>{c.reservedBonus}</span>
                               <span className={"fiat-amount"}>{c.bonusFiatExchange}</span>
                           </td>}
                       </tr>
                   ))}
                   </tbody>
               </table>
                {hasReservedAmount && (
                    <div className={"alert alert-info"}>
                        <h5 className="alert-heading">{t("balances-page.bonus-amount")}</h5>
                        {t("balances-page.bonus-amount-help")}
                    </div>
                )}
            </div>
        </div>
    )

}
export default BalancesPage;